import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a503b29"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_2 = ["onUpdate:modelValue", "placeholder"]

import DataTable, {
    DataTableFilterMeta,
    DataTableFilterMetaData,
  } from "primevue/datatable"
  import InputText from "primevue/inputtext"
  import Column from "primevue/column"
  import { AEstadoVazioTabela, MListaChips } from "@/components/Gerais"
  import { FilterMatchMode, FilterOperator } from "primevue/api"
  import { ref, computed, onUnmounted } from "vue"
  import { AtributoStore } from "@/store/atributos/atributo/atributo.store"
  import { storeToRefs } from "pinia"
  import { mapTipoDeValor } from "@/types/atributo"
  import { useI18n } from "vue-i18n"

  import { ColunasAtributos } from "@/types/atributo"
  import { ParamsAtributo } from "@/repositorios/atributos/atributos.modelos"

  interface Props {
    aguardandoAlgumaRequisicao?: boolean
    ocultarColunas?: ColunasAtributos[]
    parametros?: ParamsAtributo
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaAtributos',
  props: {
    aguardandoAlgumaRequisicao: { type: Boolean },
    ocultarColunas: null,
    parametros: null
  },
  setup(__props: any) {

const props = __props as {
    aguardandoAlgumaRequisicao?: boolean
    ocultarColunas?: ColunasAtributos[]
    parametros?: ParamsAtributo
  }

  const ALTURA_RELATIVA_DA_TABELA = "calc(100vh - 520px)"

  

  const { t } = useI18n()

  const filtros = ref<DataTableFilterMeta | undefined>({
    nome: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    natureza: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      ] as DataTableFilterMetaData[],
    },
  })

  const atributoStore = AtributoStore()
  const { listaAtributos, carregando } = storeToRefs(atributoStore)

  const carregandoAtributos = computed(
    () =>
      carregando.value("criar_atributo") || carregando.value("listar_atributo")
  )

  const removerAtributoDaTabela = (id: string) => {
    listaAtributos.value = listaAtributos.value.filter(
      (atributo) => atributo.id !== id
    )
  }

  onUnmounted(() => {
    AtributoStore().$reset()
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_PButton = _resolveComponent("PButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_unref(DataTable), {
    filters: filtros.value,
    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((filtros).value = $event)),
    class: "OAttributesTable p-datatable-sm",
    "data-key": "id",
    "filter-display": "menu",
    "global-filters-fields": ['nome', 'natureza'],
    loading: _unref(carregandoAtributos) || __props.aguardandoAlgumaRequisicao,
    paginator: true,
    "responsive-layout": "scroll",
    rows: 10,
    "scroll-height": ALTURA_RELATIVA_DA_TABELA,
    scrollable: "",
    value: _unref(listaAtributos)
  }, _createSlots({
    loading: _withCtx(() => [
      _createVNode(_component_Skeleton, {
        height: "100%",
        width: "100%"
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        class: "OAttributesTable__Column",
        field: "nome",
        header: _unref(t)('nome'),
        sortable: "",
        hidden: __props.ocultarColunas?.includes(_unref(ColunasAtributos).NOME)
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(data.nome), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _withDirectives(_createElementVNode("InputText", {
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            placeholder: _unref(t)('pesquisarPorNome'),
            type: "text"
          }, null, 8, _hoisted_1), [
            [_vModelText, filterModel.value]
          ])
        ]),
        _: 1
      }, 8, ["header", "hidden"]),
      _createVNode(_unref(Column), {
        class: "OAttributesTable__Column",
        field: "tipoDoAtributo",
        header: "natureza",
        hidden: __props.ocultarColunas?.includes(_unref(ColunasAtributos).NATUREZA)
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(data.tipoDoAtributo), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _withDirectives(_createElementVNode("InputText", {
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            placeholder: _unref(t)('pesquisarPorNatureza'),
            type: "text"
          }, null, 8, _hoisted_2), [
            [_vModelText, filterModel.value]
          ])
        ]),
        _: 1
      }, 8, ["hidden"]),
      _createVNode(_unref(Column), {
        class: "OAttributesTable__Column",
        field: "tipoDevalor",
        header: "tipo de valor",
        hidden: __props.ocultarColunas?.includes(_unref(ColunasAtributos).TIPO_DE_VALOR)
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(_unref(mapTipoDeValor)[data.tipoDeValor]), 1)
        ]),
        _: 1
      }, 8, ["hidden"]),
      _createVNode(_unref(Column), {
        class: "OAttributesTable__Column",
        field: "valoresPossiveis",
        header: _unref(t)('valoresPossiveis'),
        hidden: __props.ocultarColunas?.includes(_unref(ColunasAtributos).VALORES_POSSIVEIS)
      }, {
        body: _withCtx(({ data }) => [
          (data.valoresPossiveis)
            ? (_openBlock(), _createBlock(_unref(MListaChips), {
                key: 0,
                chips: data.valoresPossiveis,
                class: "OTabelaTiposRecursos__MListaChips",
                "exibir-somente": 3
              }, null, 8, ["chips"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["header", "hidden"]),
      _createVNode(_unref(Column), {
        class: "OAttributesTable__Column",
        field: "acoes",
        header: "",
        hidden: __props.ocultarColunas?.includes(_unref(ColunasAtributos).ACOES)
      }, {
        body: _withCtx(({ data }) => [
          _withDirectives(_createVNode(_component_PButton, {
            onClick: ($event: any) => (removerAtributoDaTabela(data.id)),
            class: "OAttributesTable__IButton p-button-rounded",
            "data-testid": "OAttributesTable__IButton",
            icon: "pi pi-trash"
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _unref(t)('excluir'),
              void 0,
              { top: true }
            ]
          ])
        ]),
        _: 1
      }, 8, ["hidden"])
    ]),
    _: 2
  }, [
    (!_unref(carregandoAtributos) && !__props.aguardandoAlgumaRequisicao)
      ? {
          name: "empty",
          fn: _withCtx(() => [
            _createVNode(_unref(AEstadoVazioTabela))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["filters", "loading", "value"]))
}
}

})